import React from 'react';
import { StringMap } from '../../util/types';
import './debug-box.scss';

interface Props {
	content: StringMap<any>;
}

function createContentJsx(content: StringMap<any>): any[] {
	const result: any[] = [];
	for (const i in content) {
		if (content.hasOwnProperty(i)) {
			result.push(
				<span key={i} className={'debug-box--wrapper'}>
					<span className={'debug-box__element'}>
						<span className={'debug-box__element--key'}>{i}</span>:&nbsp;
						<span className={'debug-box__element--value'}>{content[i]}</span>
					</span>
					<br/>
				</span>
			);
		}
	}
	return result;
}

export const DebugBox: React.FunctionComponent<Props> = props => {
	if (process.env.NODE_ENV === 'production') {
		return null;
	}
	const content: any[] = createContentJsx(props.content);
	return (
		<section className={'debug-box'}>
			{content}
		</section>
	);
};
